<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" clipped app>
      <v-list dense>
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Accueil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item to="/save" :disabled="!$store.getters.isUserLoggedIn">
          <v-list-item-action>
            <v-icon>mdi-content-save</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sauvegarder une session</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/profile" :disabled="!$store.getters.isUserLoggedIn">
          <v-list-item-action>
            <v-icon>mdi-face-profile</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mon parcours sportif</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item to="/other">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profil d'autres utilisateurs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="#f5f5f5">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <SignInButton v-if="!$store.getters.isUserLoggedIn" />
      <LogInButton v-if="!$store.getters.isUserLoggedIn" />
      <UserProfileModal v-if="$store.getters.isUserLoggedIn" />
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import LogInButton from "@/components/LogInButton.vue";
import SignInButton from "@/components/SignInButton.vue";
import UserProfileModal from "@/components/UserProfileModal.vue";
export default {
  components: {
    LogInButton,
    SignInButton,

    UserProfileModal
  },
  props: {
    source: String
  },

  data: () => ({
    drawer: null
  }),

  methods: {}
};
</script>
